<template>
  <router-view class="page site-width" />
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapActions } from 'vuex';

@Component({
  name: 'page-games-wrapper',
})
export default class PageGapesWrapper extends Vue {}
</script>
